
export const createCell = (cellType = "td", isVoid: boolean = false) => {
  const attrs: Record<string, unknown> = {}
  if (isVoid) {
    attrs.void = true
  }
  let newcol = {
    type: cellType, attrs, children: [{ text: '' }]
  }
  return JSON.parse(JSON.stringify(newcol))
}
